(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gold-set-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.gsInit === '1') return;
      root.dataset.gsInit = '1';

      var VARIANT = root.dataset.variantId;
      var addBtn = root.querySelector('[data-gs-add]');
      var priceNow = root.querySelector('[data-gs-price]');

      function money(c){ var d=(c||0)/100; return '$'+(d%1===0?d:d.toFixed(2)); }

      // variant map (Chain Length x Bracelet Size)
      var variants = [];
      var vEl = root.querySelector('[data-gs-variants]');
      if (vEl) { try { variants = JSON.parse(vEl.textContent); } catch (e) { variants = []; } }
      var multiVariant = variants.length > 1;

      var chainWrap = root.querySelector('[data-gs-chain]');
      var braceletWrap = root.querySelector('[data-gs-bracelet]');
      function selected(wrap) { var b = wrap && wrap.querySelector('.gs-opt.is-active'); return b ? b.getAttribute('data-value') : null; }

      function norm(s) { return (s || '').replace(/[”″]/g, '"').replace(/\s+/g, '').toLowerCase(); }
      function resolveVariant() {
        if (!multiVariant) return;
        var c = norm(selected(chainWrap)), b = norm(selected(braceletWrap));
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var o1 = norm(v.o1), o2 = norm(v.o2);
          if ((o1 === c && o2 === b) || (o1 === b && o2 === c)) {
            VARIANT = String(v.id);
            if (priceNow) priceNow.textContent = money(v.price);
            return;
          }
        }
      }

      [chainWrap, braceletWrap].forEach(function (wrap) {
        if (!wrap) return;
        wrap.addEventListener('click', function (e) {
          var b = e.target.closest('.gs-opt'); if (!b) return;
          Array.prototype.forEach.call(wrap.querySelectorAll('.gs-opt'), function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          resolveVariant();
        });
      });
      resolveVariant();

      function openCartDrawer() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
        setTimeout(function () {
          var cartEl = document.getElementById('sidebar-cart');
          if (cartEl && cartEl.getAttribute('aria-hidden') === 'false') return;
          var t = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]') || document.querySelector('a[href="/cart"]');
          if (t) t.click();
        }, 500);
      }

      function addToCart(btn) {
        if (!VARIANT || btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        var item = { id: parseInt(VARIANT, 10), quantity: 1 };
        if (!multiVariant) {
          item.properties = { 'Chain Length': selected(chainWrap) || '', 'Bracelet Size': selected(braceletWrap) || '' };
        }
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { btn.classList.remove('is-loading'); openCartDrawer(); })
        .catch(function () { btn.classList.remove('is-loading'); alert('Sorry — could not add to cart. Please try again.'); });
      }

      if (addBtn) addBtn.addEventListener('click', function () { addToCart(addBtn); });

      // Size Guide popup
      var sizeOpen = root.querySelector('[data-gs-size-open]');
      var sizeModal = document.querySelector('[data-gs-size-modal]');
      if (sizeOpen && sizeModal) {
        var sizeEsc = function (ev) { if (ev.key === 'Escape') sizeClose(); };
        var sizeClose = function () {
          sizeModal.hidden = true;
          document.documentElement.style.overflow = '';
          document.removeEventListener('keydown', sizeEsc);
        };
        sizeOpen.addEventListener('click', function (e) {
          e.preventDefault();
          sizeModal.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          document.addEventListener('keydown', sizeEsc);
        });
        Array.prototype.forEach.call(sizeModal.querySelectorAll('[data-gs-size-close]'), function (el) {
          el.addEventListener('click', sizeClose);
        });
      }

      // gallery — swipe + dots + desktop arrows
      var gallery = root.querySelector('[data-gs-gallery]');
      if (gallery) {
        var slides = gallery.querySelector('[data-gs-slides]');
        var dots = gallery.querySelectorAll('[data-gs-dot]');
        if (slides && dots.length) {
          var setActive = function (i) { Array.prototype.forEach.call(dots, function (d, j) { d.classList.toggle('is-active', j === i); }); };
          Array.prototype.forEach.call(dots, function (d) {
            d.addEventListener('click', function () {
              var i = parseInt(d.getAttribute('data-index'), 10) || 0;
              slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
              setActive(i);
            });
          });
          var raf;
          slides.addEventListener('scroll', function () {
            if (raf) cancelAnimationFrame(raf);
            raf = requestAnimationFrame(function () { setActive(Math.round(slides.scrollLeft / slides.clientWidth)); });
          }, { passive: true });
          var count = slides.children.length;
          var current = function () { return Math.round(slides.scrollLeft / slides.clientWidth); };
          var goTo = function (i) {
            i = Math.max(0, Math.min(count - 1, i));
            slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
            setActive(i);
          };
          var prevA = gallery.querySelector('[data-gs-prev]');
          var nextA = gallery.querySelector('[data-gs-next]');
          if (prevA) prevA.addEventListener('click', function () { goTo(current() - 1); });
          if (nextA) nextA.addEventListener('click', function () { goTo(current() + 1); });
        }
      }

      // scroll reveals
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: .15 });
        Array.prototype.forEach.call(root.querySelectorAll('.gs-reveal'), function (el) { io.observe(el); });
      } else {
        Array.prototype.forEach.call(root.querySelectorAll('.gs-reveal'), function (el) { el.classList.add('is-in'); });
      }

      // sticky bar — show after hero, hide near buy module
      var sticky = document.querySelector('[data-gs-sticky]');
      var hero = root.querySelector('.gs-hero');
      var buy = root.querySelector('#gs-buy');
      if (sticky && hero) {
        sticky.hidden = false;
        window.addEventListener('scroll', function () {
          var pastHero = hero.getBoundingClientRect().bottom < 0;
          var atBuy = buy ? (buy.getBoundingClientRect().top < window.innerHeight && buy.getBoundingClientRect().bottom > 0) : false;
          sticky.classList.toggle('is-show', pastHero && !atBuy);
        }, { passive: true });
      }
    }

    function boot(){ Array.prototype.forEach.call(document.querySelectorAll('.gs'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["imperium-3chain-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAll() {
      var roots = document.querySelectorAll('.ibb');
      Array.prototype.forEach.call(roots, function (root) {
        if (root.dataset.ibbInit === '1') return;
        root.dataset.ibbInit = '1';
        init(root);
      });
    }

    function init(root) {
      var SIZE    = parseInt(root.dataset.bundleSize, 10) || 3;
      var VARIANT = root.dataset.variantId;
      var NOW     = parseInt(root.dataset.nowPrice, 10) || 9900;

      var grid     = root.querySelector('[data-grid]');
      var slots    = Array.prototype.slice.call(root.querySelectorAll('[data-slot]'));
      var progress = root.querySelector('[data-progress]');
      var wasEl    = root.querySelector('[data-was]');
      var saveEl   = root.querySelector('[data-save]');
      var cta      = root.querySelector('[data-cta]');
      var ctaLabel = root.querySelector('[data-cta-label]');
      if (!grid || !cta) return;

      var picks = [];

      function money(cents) {
        var d = (cents || 0) / 100;
        return '$' + (d % 1 === 0 ? d : d.toFixed(2));
      }

      function lengthData(card) {
        var sw = card.querySelector('.ibb-length.is-active');
        if (!sw) return { id: '', title: '' };
        return { id: sw.getAttribute('data-variant'), title: sw.getAttribute('data-title') || sw.textContent.trim() };
      }

      function findPick(id) { for (var i = 0; i < picks.length; i++) if (picks[i].id === id) return i; return -1; }

      // "Pick 3 chains" (none yet) → "Pick 2 more" → "Pick 1 more" → null (ready)
      function remainText() {
        if (picks.length === 0) return 'Add any ' + SIZE + ' chains';
        var left = SIZE - picks.length;
        return left > 0 ? ('Add ' + left + ' more') : null;
      }

      function render() {
        slots.forEach(function (slot, i) {
          var p = picks[i];
          slot.classList.toggle('is-filled', !!p);
          Array.prototype.slice.call(slot.querySelectorAll('img, .ibb-slot-x')).forEach(function (n) { n.remove(); });
          if (p) {
            if (p.image) { var im = document.createElement('img'); im.src = p.image; im.alt = p.title; slot.appendChild(im); }
            var x = document.createElement('button');
            x.type = 'button'; x.className = 'ibb-slot-x'; x.setAttribute('aria-label', 'Remove'); x.textContent = '×';
            x.addEventListener('click', function () { removeById(p.id); });
            slot.appendChild(x);
          }
        });

        var remain = remainText();
        progress.textContent = remain || 'Bundle ready 🎉';

        var wasCents = picks.reduce(function (s, p) { return s + (p.price || 0); }, 0);
        if (picks.length === SIZE && wasCents > NOW) {
          wasEl.textContent = money(wasCents); wasEl.hidden = false;
          saveEl.textContent = 'Save ' + money(wasCents - NOW);
          saveEl.hidden = false;
        } else { wasEl.hidden = true; saveEl.hidden = true; }

        var ready = picks.length === SIZE;
        cta.disabled = !ready;
        root.classList.toggle('is-complete', ready);
        if (ctaLabel) ctaLabel.textContent = ready ? ('Add Bundle — ' + money(NOW)) : remain;

        var full = picks.length >= SIZE;
        Array.prototype.slice.call(grid.querySelectorAll('[data-card]')).forEach(function (card) {
          var selected = findPick(card.dataset.id) !== -1;
          card.classList.toggle('is-disabled', full && !selected);
        });
      }

      function removeById(id) {
        var i = findPick(id);
        if (i === -1) return;
        var card = picks[i].card;
        picks.splice(i, 1);
        card.classList.remove('is-selected');
        render();
      }

      function toggleCard(card) {
        var id = card.dataset.id;
        if (findPick(id) !== -1) { removeById(id); return; }
        if (picks.length >= SIZE) return;
        var len = lengthData(card);
        picks.push({ id: id, card: card, title: card.dataset.title, price: parseInt(card.dataset.price, 10) || 0, image: card.dataset.image, variantTitle: len.title, variantId: len.id });
        card.classList.add('is-selected');
        render();
      }

      grid.addEventListener('click', function (e) {
        // Image flip (product ↔ on-model shot)
        var media = e.target.closest('[data-flip]');
        if (media) { media.classList.toggle('is-flipped'); return; }
        // Length swatch click → set active + sync the pick if already selected
        var sw = e.target.closest('.ibb-length');
        if (sw) {
          if (sw.disabled) return;
          Array.prototype.forEach.call(sw.parentNode.querySelectorAll('.ibb-length'), function (b) { b.classList.remove('is-active'); });
          sw.classList.add('is-active');
          var swCard = sw.closest('[data-card]');
          var pi = findPick(swCard.dataset.id);
          if (pi !== -1) { var ld = lengthData(swCard); picks[pi].variantTitle = ld.title; picks[pi].variantId = ld.id; }
          return;
        }
        // Add / remove from bundle
        var btn = e.target.closest('[data-add]');
        if (!btn) return;
        var card = btn.closest('[data-card]');
        if (card.classList.contains('is-disabled')) return;
        toggleCard(card);
      });

      function openCartDrawer() {
        // Maestrooo / Prestige: our raw /cart/add.js updates the server cart
        // but NOT the theme's drawer DOM, so the drawer would show a stale
        // cart when items were already in it. This event makes the theme
        // re-fetch the cart, re-render the drawer, and open the mini-cart.
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { openMiniCart: true }
        }));
        // Fallback (non-Maestrooo builds): if the drawer didn't open, click its trigger.
        setTimeout(function () {
          var cartEl = document.getElementById('sidebar-cart');
          if (cartEl && cartEl.getAttribute('aria-hidden') === 'false') return;
          var t = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]')
               || document.querySelector('[data-action="open-drawer"][data-aside="sidebar-cart"]')
               || document.querySelector('a[href="/cart"], a[href^="/cart?"]');
          if (t) t.click();
        }, 500);
      }

      cta.addEventListener('click', function () {
        if (cta.disabled || cta.classList.contains('is-loading')) return;
        if (picks.length !== SIZE || !VARIANT) return;

        var props = {};
        picks.forEach(function (p, i) {
          // Shorten for ShipRush: "Franco Chain (Gold)" + "3mm — 20"" -> "Franco GOLD 3mm 20""
          var name = (p.title || '')
            .replace(/\bchain\b/ig, '')                    // drop the word "Chain"
            .replace(/[()]/g, '')                          // drop parentheses around color
            .replace(/\b(gold|silver)\b/ig, function (m) { // force color to ALL CAPS
              return m.toUpperCase();
            })
            .replace(/\s+/g, ' ')                          // collapse double spaces
            .trim();
          var len = (p.variantTitle && p.variantTitle !== 'Default Title')
            ? p.variantTitle.replace(/\s*[—–-]\s*/g, ' ').replace(/\s+/g, ' ').trim()
            : '';
          var label = (len ? name + ' ' + len : name);
          props[(i + 1) + ''] = label;
        });

        cta.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(VARIANT, 10), quantity: 1, properties: props }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { cta.classList.remove('is-loading'); openCartDrawer(); })
          .catch(function () { cta.classList.remove('is-loading'); alert('Sorry — could not add the bundle. Please try again.'); });
      });

      render();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["worldcup-pendant-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.wcpInit === '1') return;
      root.dataset.wcpInit = '1';

      var VARIANT = root.dataset.variantId;
      var lengths = root.querySelector('[data-lengths]');
      var stickySelect = document.querySelector('[data-sticky-select]');
      var priceNow = root.querySelector('[data-buy-price]');
      var priceWas = root.querySelector('[data-buy-compare]');
      var addBtn  = root.querySelector('[data-add]');

      function money(c){ var d=(c||0)/100; return '$'+(d%1===0?d:d.toFixed(2)); }

      // bundle / volume tiers
      var QTY = 1;
      var bundlesEl = root.querySelector('[data-bundles]');
      var bundleEls = bundlesEl ? bundlesEl.querySelectorAll('[data-bundle]') : [];
      var addLabel = root.querySelector('[data-add-label]');
      var CTA_BASE = addLabel ? addLabel.textContent.trim() : 'Add to Cart';
      var unitPrice = bundlesEl ? (parseInt(bundlesEl.getAttribute('data-unit'), 10) || 0) : 0;
      var activeBundle = bundlesEl ? (bundlesEl.querySelector('[data-bundle].is-active') || bundleEls[0]) : null;
      if (activeBundle) QTY = parseInt(activeBundle.getAttribute('data-qty'), 10) || 1;
      function bundleSave() { return activeBundle ? (parseInt(activeBundle.getAttribute('data-save'), 10) || 0) : 0; }
      function renderBundles() {
        Array.prototype.forEach.call(bundleEls, function (b) {
          var q = parseInt(b.getAttribute('data-qty'), 10) || 1, s = parseInt(b.getAttribute('data-save'), 10) || 0;
          var w = b.querySelector('[data-bundle-was]'), n = b.querySelector('[data-bundle-now]');
          if (w) w.textContent = money(unitPrice * q);
          if (n) n.textContent = money(unitPrice * q - s);
        });
      }
      function updateBundleTotal() {
        if (!bundlesEl) return;
        var total = unitPrice * QTY - bundleSave();
        if (addLabel) addLabel.textContent = CTA_BASE + ' · ' + money(total);
        var sp = document.querySelector('[data-sticky-price]'); if (sp) sp.textContent = money(total);
      }

      function applyVariant(id, price, compare) {
        VARIANT = String(id);
        if (priceNow && !isNaN(price)) priceNow.textContent = money(price);
        if (priceWas) { if (compare && compare > price) { priceWas.textContent = money(compare); priceWas.style.display = ''; } else { priceWas.style.display = 'none'; } }
        var sp = document.querySelector('[data-sticky-price]'); if (sp && !isNaN(price)) sp.textContent = money(price);
        if (lengths) { Array.prototype.forEach.call(lengths.querySelectorAll('.wcp-length'), function (x) { x.classList.toggle('is-active', x.getAttribute('data-variant') === VARIANT); }); }
        if (stickySelect && stickySelect.value !== VARIANT) stickySelect.value = VARIANT;
        if (bundlesEl && !isNaN(price)) { unitPrice = price; renderBundles(); updateBundleTotal(); }
      }

      // length swatches (buy module)
      if (lengths) {
        lengths.addEventListener('click', function (e) {
          var b = e.target.closest('.wcp-length'); if (!b || b.disabled) return;
          applyVariant(b.getAttribute('data-variant'), parseInt(b.getAttribute('data-price'), 10), parseInt(b.getAttribute('data-compare'), 10));
        });
      }

      // length dropdown (sticky bar)
      if (stickySelect) {
        stickySelect.addEventListener('change', function () {
          var opt = stickySelect.options[stickySelect.selectedIndex];
          applyVariant(stickySelect.value, parseInt(opt.getAttribute('data-price'), 10), parseInt(opt.getAttribute('data-compare'), 10));
        });
      }

      // bundle tier selection
      Array.prototype.forEach.call(bundleEls, function (b) {
        b.addEventListener('click', function () {
          Array.prototype.forEach.call(bundleEls, function (x) { x.classList.toggle('is-active', x === b); });
          activeBundle = b;
          QTY = parseInt(b.getAttribute('data-qty'), 10) || 1;
          updateBundleTotal();
        });
      });
      if (bundlesEl) { renderBundles(); updateBundleTotal(); }

      // Size Guide — our own popup
      var sizeOpen = root.querySelector('[data-size-open]');
      var sizeModal = document.querySelector('[data-size-modal]');
      if (sizeOpen && sizeModal) {
        var sizeEsc = function (ev) { if (ev.key === 'Escape') sizeClose(); };
        var sizeClose = function () {
          sizeModal.hidden = true;
          document.documentElement.style.overflow = '';
          document.removeEventListener('keydown', sizeEsc);
        };
        sizeOpen.addEventListener('click', function (e) {
          e.preventDefault();
          sizeModal.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          document.addEventListener('keydown', sizeEsc);
        });
        Array.prototype.forEach.call(sizeModal.querySelectorAll('[data-size-close]'), function (el) {
          el.addEventListener('click', sizeClose);
        });
      }

      // Info cards — accordion (per-card panel; CSS grid handles row vs stacked)
      var infoAcc = root.querySelector('[data-info-acc]');
      if (infoAcc) {
        var infoCards = infoAcc.querySelectorAll('[data-info-card]');
        var infoPanels = infoAcc.querySelectorAll('[data-info-panel]');
        var infoActive = -1;
        var infoSet = function (i, open) {
          if (infoPanels[i]) infoPanels[i].style.height = open ? (infoPanels[i].scrollHeight + 'px') : '0px';
          if (infoCards[i]) { infoCards[i].classList.toggle('is-open', open); infoCards[i].setAttribute('aria-expanded', open ? 'true' : 'false'); }
        };
        Array.prototype.forEach.call(infoCards, function (card, i) {
          card.addEventListener('click', function () {
            if (infoActive === i) { infoSet(i, false); infoActive = -1; }
            else { if (infoActive >= 0) infoSet(infoActive, false); infoSet(i, true); infoActive = i; }
          });
        });
        window.addEventListener('resize', function () { if (infoActive >= 0) infoPanels[infoActive].style.height = infoPanels[infoActive].scrollHeight + 'px'; });
      }

      function openCartDrawer() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
        setTimeout(function () {
          var cartEl = document.getElementById('sidebar-cart');
          if (cartEl && cartEl.getAttribute('aria-hidden') === 'false') return;
          var t = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]') || document.querySelector('a[href="/cart"]');
          if (t) t.click();
        }, 500);
      }

      function addToCart(btn) {
        if (!VARIANT || btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(VARIANT,10), quantity: QTY }] })
        })
        .then(function (r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){ btn.classList.remove('is-loading'); openCartDrawer(); })
        .catch(function(){ btn.classList.remove('is-loading'); alert('Sorry — could not add to cart. Please try again.'); });
      }

      if (addBtn) addBtn.addEventListener('click', function(){ addToCart(addBtn); });
      var stickyAdd = document.querySelector('[data-sticky-add]');
      if (stickyAdd) stickyAdd.addEventListener('click', function(){ addToCart(stickyAdd); });

      // product image gallery — swipeable slides synced with dots/lines
      var gallery = root.querySelector('[data-buy-gallery]');
      if (gallery) {
        var slides = gallery.querySelector('[data-buy-slides]');
        var dots = gallery.querySelectorAll('[data-buy-dot]');
        if (slides && dots.length) {
          var setActive = function (i) {
            Array.prototype.forEach.call(dots, function (d, j) { d.classList.toggle('is-active', j === i); });
          };
          Array.prototype.forEach.call(dots, function (d) {
            d.addEventListener('click', function () {
              var i = parseInt(d.getAttribute('data-index'), 10) || 0;
              slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
              setActive(i);
            });
          });
          var raf;
          slides.addEventListener('scroll', function () {
            if (raf) cancelAnimationFrame(raf);
            raf = requestAnimationFrame(function () {
              setActive(Math.round(slides.scrollLeft / slides.clientWidth));
            });
          }, { passive: true });

          // desktop prev/next arrows
          var count = slides.children.length;
          var current = function () { return Math.round(slides.scrollLeft / slides.clientWidth); };
          var goTo = function (i) {
            i = Math.max(0, Math.min(count - 1, i));
            slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
            setActive(i);
          };
          var prevA = gallery.querySelector('[data-buy-prev]');
          var nextA = gallery.querySelector('[data-buy-next]');
          if (prevA) prevA.addEventListener('click', function () { goTo(current() - 1); });
          if (nextA) nextA.addEventListener('click', function () { goTo(current() + 1); });
        }
      }

      // scroll reveals
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: .15 });
        Array.prototype.forEach.call(root.querySelectorAll('.wcp-reveal'), function(el){ io.observe(el); });
      } else {
        Array.prototype.forEach.call(root.querySelectorAll('.wcp-reveal'), function(el){ el.classList.add('is-in'); });
      }

      // worn-worldwide country carousel
      var track = root.querySelector('[data-wear-track]');
      if (track) {
        var prevB = root.querySelector('[data-wear-prev]');
        var nextB = root.querySelector('[data-wear-next]');
        var prog = root.querySelector('[data-wear-progress]');
        var updateProg = function () {
          if (!prog) return;
          var max = track.scrollWidth - track.clientWidth;
          var frac = max > 0 ? (track.scrollLeft + track.clientWidth) / track.scrollWidth : 1;
          prog.style.width = (Math.max(0, Math.min(1, frac)) * 100) + '%';
        };
        track.addEventListener('scroll', updateProg, { passive: true });
        window.addEventListener('resize', updateProg);
        window.addEventListener('load', updateProg);
        updateProg();
        var step = function(){ var c = track.querySelector('.wcp-wear-card'); return c ? (c.getBoundingClientRect().width + 16) : 336; };
        var go = function(dir){ track.scrollBy({ left: dir * step(), behavior: 'smooth' }); };
        if (prevB) prevB.addEventListener('click', function(){ go(-1); });
        if (nextB) nextB.addEventListener('click', function(){ go(1); });

        // drag-to-scroll with the mouse on desktop (touch keeps native swipe)
        var down = false, dragStartX = 0, dragStartLeft = 0, dragged = false;
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch') return;
          down = true; dragged = false;
          dragStartX = e.clientX; dragStartLeft = track.scrollLeft;
          track.classList.add('is-dragging');
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        });
        track.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - dragStartX;
          if (Math.abs(dx) > 3) dragged = true;
          track.scrollLeft = dragStartLeft - dx;
        });
        var endDrag = function (e) {
          if (!down) return;
          down = false;
          track.classList.remove('is-dragging');
          try { if (e) track.releasePointerCapture(e.pointerId); } catch (err) {}
        };
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        track.addEventListener('click', function (e) { if (dragged) { e.preventDefault(); e.stopPropagation(); } }, true);
        track.addEventListener('dragstart', function (e) { e.preventDefault(); });

        track.scrollLeft = 0; // rest on the first card (USA), no auto-advance
      }

      // detail video — mobile = scroll-scrub (no pin), desktop = autoplay loop
      var scrubV = root.querySelector('[data-wcp-scrub-video]');
      if (scrubV) {
        var sSrc = scrubV.getAttribute('data-src');
        if (sSrc && !scrubV.querySelector('source')) {
          var ss = document.createElement('source'); ss.src = sSrc; ss.type = 'video/mp4'; scrubV.appendChild(ss);
        }
        var sStage = scrubV.closest('[data-wcp-scrub]') || scrubV;
        scrubV.setAttribute('preload', 'auto');
        scrubV.load();

        if (!window.matchMedia('(max-width: 820px)').matches) {
          // desktop: gentle autoplay loop
          scrubV.loop = true; scrubV.muted = true;
          var dp = scrubV.play(); if (dp && dp.catch) dp.catch(function(){});
        } else {
          // mobile: timeline tied to how far the video has travelled through the viewport
          var sDur = 0, sReady = false, sTarget = 0, sCurrent = 0, sUnlocked = false;
          var sClamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
          var sCompute = function () {
            if (!sReady) return;
            var r = sStage.getBoundingClientRect();
            var vh = window.innerHeight || document.documentElement.clientHeight;
            var travel = vh + r.height;
            var scrolled = vh - r.top;
            var prog = sClamp(scrolled / travel, 0, 1);
            sTarget = prog * Math.max(0, sDur - 0.05);
          };
          var sLoop = function () {
            sCurrent += (sTarget - sCurrent) * 0.22;
            if (Math.abs(sTarget - sCurrent) < 0.004) sCurrent = sTarget;
            if (sReady && scrubV.readyState >= 1 && Math.abs(scrubV.currentTime - sCurrent) > 0.01) {
              try { scrubV.currentTime = sCurrent; } catch (e) {}
            }
            requestAnimationFrame(sLoop);
          };
          var sUnlock = function () {
            if (sUnlocked) return; sUnlocked = true;
            var p = scrubV.play();
            if (p && p.then) { p.then(function () { scrubV.pause(); }).catch(function () {}); }
            else { try { scrubV.pause(); } catch (e) {} }
          };
          scrubV.addEventListener('loadedmetadata', function () { sDur = scrubV.duration || 5; sReady = true; sCompute(); });
          ['touchstart', 'scroll', 'click'].forEach(function (ev) { window.addEventListener(ev, sUnlock, { once: true, passive: true }); });
          window.addEventListener('scroll', sCompute, { passive: true });
          window.addEventListener('resize', sCompute);
          sCompute();
          requestAnimationFrame(sLoop);
        }
      }

      // sticky bar — show after hero scrolls past, hide near the buy module
      var sticky = document.querySelector('[data-sticky]');
      var hero = root.querySelector('.wcp-hero');
      var buy  = root.querySelector('#wcp-buy');
      if (sticky && hero) {
        sticky.hidden = false;
        window.addEventListener('scroll', function () {
          var pastHero = hero.getBoundingClientRect().bottom < 0;
          var atBuy = buy ? (buy.getBoundingClientRect().top < window.innerHeight && buy.getBoundingClientRect().bottom > 0) : false;
          sticky.classList.toggle('is-show', pastHero && !atBuy);
        }, { passive: true });
      }
    }

    function boot(){ Array.prototype.forEach.call(document.querySelectorAll('.wcp'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["worldcup-scrub"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.wcsReady) return;
    root.dataset.wcsReady = '1';

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var isDesktopLoop = !isMobile && root.classList.contains('wcs--desktop-loop');
    if (!isMobile && !isDesktopLoop) return; // hidden on desktop

    var stage = root.querySelector('[data-wcs-stage]');
    var video = root.querySelector('[data-wcs-video]');
    if (!video) return;

    // Attach source only when we actually need it (keeps desktop from downloading).
    var src = video.getAttribute('data-src');
    if (src && !video.querySelector('source')) {
      var s = document.createElement('source');
      s.src = src; s.type = 'video/mp4';
      video.appendChild(s);
    }

    // Desktop = plain autoplay loop.
    if (isDesktopLoop) {
      video.loop = true; video.muted = true; video.setAttribute('preload', 'auto');
      video.load();
      var pr = video.play(); if (pr && pr.catch) pr.catch(function () {});
      return;
    }

    // ---- Mobile: scrub tied to natural travel through the viewport (no pin) ----
    video.setAttribute('preload', 'auto');
    video.load();

    var dur = 0, ready = false, target = 0, current = 0, unlocked = false;
    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

    video.addEventListener('loadedmetadata', function () {
      dur = video.duration || 5; ready = true; computeTarget();
    });

    // iOS won't seek a video that has never started — silently unlock on first interaction.
    function unlock() {
      if (unlocked) return; unlocked = true;
      var p = video.play();
      if (p && p.then) { p.then(function () { video.pause(); }).catch(function () {}); }
      else { try { video.pause(); } catch (e) {} }
    }
    ['touchstart', 'scroll', 'click'].forEach(function (ev) {
      window.addEventListener(ev, unlock, { once: true, passive: true });
    });

    function computeTarget() {
      if (!ready) return;
      var rect = stage.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var travel = vh + rect.height;                 // enter bottom -> exit top
      var scrolled = vh - rect.top;                   // 0 when top hits bottom edge
      var progress = clamp(scrolled / travel, 0, 1);  // centered ~= 0.5
      target = progress * Math.max(0, dur - 0.05);
    }

    function loop() {
      current += (target - current) * 0.22;           // ease toward scroll target
      if (Math.abs(target - current) < 0.004) current = target;
      if (ready && video.readyState >= 1 && Math.abs(video.currentTime - current) > 0.01) {
        try { video.currentTime = current; } catch (e) {}
      }
      requestAnimationFrame(loop);
    }

    window.addEventListener('scroll', computeTarget, { passive: true });
    window.addEventListener('resize', computeTarget);
    computeTarget();
    requestAnimationFrame(loop);
  }

  function boot() { document.querySelectorAll('[data-wcs]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
